import * as api from '../api/dashboard';
import { makeApiActionCreatorV3 } from '@actions/utils';

const namespace = 'APPRAISAL/DASHBOARD';

export const FETCH_DASHBOARDS_START = `${namespace}/FETCH_DASHBOARDS_START`;
export const FETCH_DASHBOARDS_SUCCESS = `${namespace}/FETCH_DASHBOARDS_SUCCESS`;
export const FETCH_DASHBOARDS_ERROR = `${namespace}/FETCH_DASHBOARDS_ERROR`;

export const fetchDashboards = makeApiActionCreatorV3(
  api.fetchDashboards,
  FETCH_DASHBOARDS_START,
  FETCH_DASHBOARDS_SUCCESS,
  FETCH_DASHBOARDS_ERROR,
);

export const FETCH_DASHBOARDS_BY_QUEUE_START = `${namespace}/FETCH_DASHBOARDS_BY_QUEUE_START`;
export const FETCH_DASHBOARDS_BY_QUEUE_SUCCESS = `${namespace}/FETCH_DASHBOARDS_BY_QUEUE_SUCCESS`;
export const FETCH_DASHBOARDS_BY_QUEUE_ERROR = `${namespace}/FETCH_DASHBOARDS_BY_QUEUE_ERROR`;

export const fetchDashboardsByQueue = makeApiActionCreatorV3(
  api.fetchDashboardsByQueue,
  FETCH_DASHBOARDS_BY_QUEUE_START,
  FETCH_DASHBOARDS_BY_QUEUE_SUCCESS,
  FETCH_DASHBOARDS_BY_QUEUE_ERROR,
);

export const FETCH_DASHBOARDS_DETAILS_START = `${namespace}/FETCH_DASHBOARDS_DETAILS_START`;
export const FETCH_DASHBOARDS_DETAILS_SUCCESS = `${namespace}/FETCH_DASHBOARDS_DETAILS_SUCCESS`;
export const FETCH_DASHBOARDS_DETAILS_ERROR = `${namespace}/FETCH_DASHBOARDS_DETAILS_ERROR`;

export const fetchDashboardDetails = makeApiActionCreatorV3(
  api.fetchDashboardDetails,
  FETCH_DASHBOARDS_DETAILS_START,
  FETCH_DASHBOARDS_DETAILS_SUCCESS,
  FETCH_DASHBOARDS_DETAILS_ERROR,
);

export const FETCH_DASHBOARDS_QUEUE_DETAILS_START = `${namespace}/FETCH_DASHBOARDS_QUEUE_DETAILS_START`;
export const FETCH_DASHBOARDS_QUEUE_DETAILS_SUCCESS = `${namespace}/FETCH_DASHBOARDS_QUEUE_DETAILS_SUCCESS`;
export const FETCH_DASHBOARDS_QUEUE_DETAILS_ERROR = `${namespace}/FETCH_DASHBOARDS_QUEUE_DETAILS_ERROR`;

export const fetchDashboardQueueDetails = makeApiActionCreatorV3(
  api.fetchDashboardQueueDetails,
  FETCH_DASHBOARDS_QUEUE_DETAILS_START,
  FETCH_DASHBOARDS_QUEUE_DETAILS_SUCCESS,
  FETCH_DASHBOARDS_QUEUE_DETAILS_ERROR,
);

export const FETCH_DASHBOARDS_ROLE_START = `${namespace}/FETCH_DASHBOARDS_ROLE_START`;
export const FETCH_DASHBOARDS_ROLE_SUCCESS = `${namespace}/FETCH_DASHBOARDS_ROLE_SUCCESS`;
export const FETCH_DASHBOARDS_ROLE_ERROR = `${namespace}/FETCH_DASHBOARDS_ROLE_ERROR`;

export const fetchDashboardsByRole = makeApiActionCreatorV3(
  api.fetchDashboardsByRole,
  FETCH_DASHBOARDS_ROLE_START,
  FETCH_DASHBOARDS_ROLE_SUCCESS,
  FETCH_DASHBOARDS_ROLE_ERROR,
);

export const FETCH_DASHBOARD_QUERY_RESULTS_START = `${namespace}/FETCH_DASHBOARD_QUERY_RESULTS_START`;
export const FETCH_DASHBOARD_QUERY_RESULTS_SUCCESS = `${namespace}/FETCH_DASHBOARD_QUERY_RESULTS_SUCCESS`;
export const FETCH_DASHBOARD_QUERY_RESULTS_ERROR = `${namespace}/FETCH_DASHBOARD_QUERY_RESULTS_ERROR`;

export const fetchDashboardQueryResults = makeApiActionCreatorV3(
  api.fetchDashboardQueryResults,
  FETCH_DASHBOARD_QUERY_RESULTS_START,
  FETCH_DASHBOARD_QUERY_RESULTS_SUCCESS,
  FETCH_DASHBOARD_QUERY_RESULTS_ERROR,
);

export const EXECUTE_DASHBOARD_START = `${namespace}/EXECUTE_DASHBOARD_START`;
export const EXECUTE_DASHBOARD_SUCCESS = `${namespace}/EXECUTE_DASHBOARD_SUCCESS`;
export const EXECUTE_DASHBOARD_ERROR = `${namespace}/EXECUTE_DASHBOARD_ERROR`;

export const executeDashboard = makeApiActionCreatorV3(
  api.executeDashboard,
  EXECUTE_DASHBOARD_START,
  EXECUTE_DASHBOARD_SUCCESS,
  EXECUTE_DASHBOARD_ERROR,
);

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;

export const changePage = (page) => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changeRowsPerPage = (rowsPerPage) => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const SET_SELECTED_DASHBOARD_TITLE = `${namespace}/SET_SELECTED_DASHBOARD_TITLE`;

export const setSelectedDashboardTitle = (data) => ({
  type: SET_SELECTED_DASHBOARD_TITLE,
  payload: data,
});

export const SET_SELECTED_DASHBOARD_YEAR = `${namespace}/SET_SELECTED_DASHBOARD_YEAR`;

export const setSelectedDashboardYear = (data) => ({
  type: SET_SELECTED_DASHBOARD_YEAR,
  payload: data,
});

export const SET_SELECTED_DASHBOARD_STARTDT = `${namespace}/SET_SELECTED_DASHBOARD_STARTDT`;

export const setSelectedDashboardStartDt = (data) => ({
  type: SET_SELECTED_DASHBOARD_STARTDT,
  payload: data,
});

export const SET_SELECTED_DASHBOARD_ENDDT = `${namespace}/SET_SELECTED_DASHBOARD_ENDDT`;

export const setSelectedDashboardEndDt = (data) => ({
  type: SET_SELECTED_DASHBOARD_ENDDT,
  payload: data,
});

export const SET_SELECTED_QUERY_TITLE = `${namespace}/SET_SELECTED_QUERY_TITLE`;

export const setSelectedQueryTitle = (data) => ({
  type: SET_SELECTED_QUERY_TITLE,
  payload: data,
});

export const SET_SELECTED_QUERY_YEAR = `${namespace}/SET_SELECTED_QUERY_YEAR`;

export const setSelectedQueryYear = (data) => ({
  type: SET_SELECTED_QUERY_YEAR,
  payload: data,
});

export const SET_SELECTED_QUERY_STARTDT = `${namespace}/SET_SELECTED_QUERY_STARTDT`;

export const setSelectedQueryStartDt = (data) => ({
  type: SET_SELECTED_QUERY_STARTDT,
  payload: data,
});

export const SET_SELECTED_QUERY_ENDDT = `${namespace}/SET_SELECTED_QUERY_ENDDT`;

export const setSelectedQueryEndDt = (data) => ({
  type: SET_SELECTED_QUERY_ENDDT,
  payload: data,
});

export const SET_SELECTED_QUERY_STRING = `${namespace}/SET_SELECTED_QUERY_STRING`;

export const setSelectedQueryString = (data) => ({
  type: SET_SELECTED_QUERY_STRING,
  payload: data,
});

export const SET_SELECTED_QUERY_ID = `${namespace}/SET_SELECTED_QUERY_ID`;

export const setSelectedQueryID = (data) => ({
  type: SET_SELECTED_QUERY_ID,
  payload: data,
});

export const SET_SELECTED_VIEW_MODE = `${namespace}/SET_SELECTED_VIEW_MODE`;

export const setSelectedViewMode = (data) => ({
  type: SET_SELECTED_VIEW_MODE,
  payload: data,
});

export const SET_DASHBOARD_LIST = `${namespace}/SET_DASHBOARD_LIST`;

export const setDashboardList = (data) => ({
  type: SET_DASHBOARD_LIST,
  payload: data,
});
